module.exports = __webpack_public_path__ + "img/custom.140ace48.png";